import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { Activity, Heart, TrendingUp, Repeat } from 'lucide-react';

const SECTIONS = [
  { key: 'activity', label: 'Audience Activity', icon: Activity, body: 'Live audience activity (joins, chat volume, reactions) will appear here once a live session has measurable data.' },
  { key: 'engagement', label: 'Engagement Behavior', icon: Heart, body: 'How your audience interacts during a live session — comments, reactions, and gifts — will be summarized here.' },
  { key: 'growth', label: 'Audience Growth', icon: TrendingUp, body: 'New followers and viewer growth gained during live sessions will be tracked here once supported.' },
  { key: 'retention', label: 'Viewer Retention', icon: Repeat, body: 'How long viewers stay in your stream, and when they tend to drop off, will be shown here once supported.' },
];

/** Audience Intelligence detail dialog — read-only, future-facing layout.
 * No demographics, growth figures, or retention rates are invented; every
 * section stays a concise empty state until real live audience data is
 * available. */
export default function LiveAudienceDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#14171F] border-white/10 sm:max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="live-audience-dialog">
        <DialogHeader><DialogTitle className="text-white">Audience Intelligence</DialogTitle></DialogHeader>
        <p className="text-xs text-[#8A93A6] -mt-3">Read-only — audience measurements will appear here once supported live data becomes available.</p>

        <Accordion type="single" collapsible className="border border-white/10 rounded-lg px-3" data-testid="live-audience-accordion">
          {SECTIONS.map((s) => (
            <AccordionItem key={s.key} value={s.key} className="border-white/10">
              <AccordionTrigger className="text-white text-sm hover:no-underline" data-testid={`live-audience-trigger-${s.key}`}>
                <span className="flex items-center gap-2"><s.icon className="h-4 w-4 text-[#8A93A6]" />{s.label}</span>
              </AccordionTrigger>
              <AccordionContent className="text-xs text-[#8A93A6]">{s.body}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </DialogContent>
    </Dialog>
  );
}
